var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChrome(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 599.7 165.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DB4437",
    d: "M13.1 38v63.4h37l32.5-56.3h73.6C142.5 18.3 114.7 0 82.6 0 53.4 0 27.8 15.1 13.1 38z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 31.876,
    y1: 88.608,
    x2: 81.16,
    y2: 117.397,
    gradientTransform: "matrix(1 0 0 -1 -7 159.82)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a52714",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#a52714",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M13.1 38v63.4h37l32.5-56.3h73.6C142.5 18.3 114.7 0 82.6 0 53.4 0 27.8 15.1 13.1 38z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#3E2723",
    fillOpacity: 0.15,
    d: "M13.1 38l37.1 63.5.8-.5-37.3-64c-.2.4-.4.7-.6 1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#0F9D58",
    d: "M78.7 165.1l36.4-36.4v-27.3h-65L13.1 38C4.8 50.8 0 66.2 0 82.6c0 44.3 34.9 80.5 78.7 82.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 108.026,
    y1: 20.515,
    x2: 53.267,
    y2: 52.592,
    gradientTransform: "matrix(1 0 0 -1 -7 159.82)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#055524",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#055524",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M78.7 165.1l36.4-36.4v-27.3h-65L13.1 38C4.8 50.8 0 66.2 0 82.6c0 44.3 34.9 80.5 78.7 82.5z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    fillOpacity: 0.15,
    d: "M77.7 165.1c.3 0 .7 0 1 .1l35.7-62.5-.8-.5-35.9 62.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFCD40",
    d: "M78.7 165.1l36.4-36.4v-27.3l-36.4 63.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientUnits: "userSpaceOnUse",
    x1: 84.006,
    y1: 113.753,
    x2: 97.796,
    y2: 53.367,
    gradientTransform: "matrix(1 0 0 -1 -7 159.82)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ea6100",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#ea6100",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M78.7 165.1l36.4-36.4v-27.3l-36.4 63.7z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFCD40",
    points: "115.1 101.4 115.1 101.4 115.1 101.4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientUnits: "userSpaceOnUse",
    x1: 122.072,
    y1: 58.72,
    x2: 122.203,
    y2: 58.15,
    gradientTransform: "matrix(1 0 0 -1 -7 159.82)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ea6100",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#ea6100",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#d)",
    points: "115.1 101.4 115.1 101.4 115.1 101.4"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFCD40",
    d: "M82.6 45.1l32.5 56.3-36.4 63.7c1.3.1 2.6.1 3.9.1 45.6 0 82.6-37 82.6-82.6 0-13.5-3.3-26.3-9-37.5H82.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    gradientUnits: "userSpaceOnUse",
    x1: 110.858,
    y1: 119.885,
    x2: 124.648,
    y2: 59.499,
    gradientTransform: "matrix(1 0 0 -1 -7 159.82)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ea6100",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#ea6100",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M82.6 45.1l32.5 56.3-36.4 63.7c1.3.1 2.6.1 3.9.1 45.6 0 82.6-37 82.6-82.6 0-13.5-3.3-26.3-9-37.5H82.6z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "f",
    cx: 662.024,
    cy: 114.808,
    r: 78.928,
    gradientTransform: "matrix(1 0 0 -1 -583 159.82)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3e2723",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3e2723",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#f)",
    points: "156.2 45.1 82.6 45.1 82.6 64.7 156.2 45.1"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#0F9D58",
    points: "50.1 101.4 50.1 101.4 50.1 101.3 50.1 101.4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    gradientUnits: "userSpaceOnUse",
    x1: 111.558,
    y1: 26.543,
    x2: 56.799,
    y2: 58.62,
    gradientTransform: "matrix(1 0 0 -1 -7 159.82)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#055524",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#055524",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#g)",
    points: "50.1 101.4 50.1 101.4 50.1 101.3 50.1 101.4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "h",
    cx: 596.03,
    cy: 121.782,
    r: 73.264,
    gradientTransform: "matrix(1 0 0 -1 -583 159.82)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3e2723",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3e2723",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#h)",
    points: "13.1 38 50.1 101.4 66.9 91.7 13.1 38"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "i",
    cx: 665.46,
    cy: 77.08,
    r: 82.488,
    gradientTransform: "matrix(1 0 0 -1 -583 159.82)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#263238",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#263238",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#i)",
    points: "115.1 101.4 98.4 91.7 78.7 165.1"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-7 -7)"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#F1F1F1",
    cx: 89.6,
    cy: 89.6,
    r: 37.5
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4285F4",
    cx: 89.6,
    cy: 89.6,
    r: 30
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#3E2723",
    fillOpacity: 0.2,
    d: "M155.7 44.1H82.6c-20.7 0-37.5 16.8-37.5 37.5v.9C45.1 61.8 61.9 45 82.6 45h73.5c-.1-.3-.2-.6-.4-.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    fillOpacity: 0.1,
    d: "M83.2 120.1h-.6c-13.9 0-26-7.6-32.5-18.8L13.1 38c-.1.1-.2.3-.3.4l37.3 63.9c6.5 11.2 18.6 18.8 32.5 18.8 10.4 0 19.9-4.3 26.7-11.2-6.7 6.3-15.8 10.2-25.7 10.2-.2.1-.3 0-.4 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    fillOpacity: 0.1,
    d: "M95.7 117.8c.2-.1.4-.2.6-.2-.2 0-.4.1-.6.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    fillOpacity: 0.1,
    d: "M97.6 117c.6-.2 1.1-.5 1.7-.8-.6.3-1.1.6-1.7.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    fillOpacity: 0.1,
    d: "M93.9 118.4c.1 0 .2-.1.3-.1-.1 0-.2.1-.3.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    fillOpacity: 0.1,
    d: "M115.1 101.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    fillOpacity: 0.1,
    d: "M100 115.9c.5-.2.9-.5 1.4-.8-.5.3-1 .5-1.4.8z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fill: "#3E2723",
    d: "M120.2 82.6z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fill: "#3E2723",
    d: "M115.1 101.4z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fill: "#3E2723",
    d: "M120.1 80.1v-.2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fill: "#3E2723",
    d: "M120 85.6V85c.1.1.1.3 0 .6z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fill: "#3E2723",
    d: "M109.3 109.9l2.4-2.4.4-.7c-.9 1.1-1.8 2.1-2.8 3.1z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fill: "#3E2723",
    d: "M119.1 73.6c.9 3.3 1.4 6.7 1.4 10.3 0 5.7-1.3 11-3.6 15.9 2.6-5.1 4.2-11 4.2-17.2 0-20.7-16.8-37.5-37.5-37.5h-.5c17.4.2 32 12.3 36 28.5z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fill: "#3E2723",
    d: "M119.8 87.8c0-.2 0-.3.1-.5-.1.2-.1.4-.1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fill: "#3E2723",
    d: "M94.2 118.3c.5-.2 1-.3 1.4-.5-.4.2-.9.3-1.4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fill: "#3E2723",
    d: "M96.3 117.6c.4-.2.9-.3 1.3-.5-.4.1-.9.3-1.3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fill: "#3E2723",
    d: "M101.3 115.1c.2-.1.3-.2.5-.3-.1.1-.3.2-.5.3z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fill: "#3E2723",
    d: "M99.3 116.2c.2-.1.4-.2.7-.4-.3.2-.5.3-.7.4z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fill: "#3E2723",
    d: "M83.1 120.1h.1c3.7-.1 7.3-.7 10.7-1.7-3.4 1.1-7 1.7-10.8 1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    fillOpacity: 0.1,
    d: "M115.1 101.4c-3.2 5.5-7.8 10.2-13.3 13.5-.2.1-.3.2-.5.3-.5.3-.9.5-1.4.8-.2.1-.4.2-.7.4-.5.3-1.1.5-1.7.8-.4.2-.9.4-1.3.5-.2.1-.4.2-.6.2-.5.2-.9.3-1.4.5-.1 0-.2.1-.3.1-3.4 1.1-7 1.7-10.7 1.7h.3c10 0 19-3.9 25.7-10.2 1-1 1.9-2.1 2.8-3.2l3.1-5.4z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fill: "#3E2723",
    d: "M115.1 101.4c-3.2 5.5-7.8 10.2-13.3 13.5-.2.1-.3.2-.5.3-.5.3-.9.5-1.4.8-.2.1-.4.2-.7.4-.5.3-1.1.5-1.7.8-.4.2-.9.4-1.3.5-.2.1-.4.2-.6.2-.5.2-.9.3-1.4.5-.1 0-.2.1-.3.1-3.4 1.1-7 1.7-10.7 1.7h.3c10 0 19-3.9 25.7-10.2 1-1 1.9-2.1 2.8-3.2l3.1-5.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    fillOpacity: 0.2,
    d: "M119.1 73.6c-.1-.4-.2-.7-.3-1.1.7 2.4 1.1 4.8 1.3 7.4v.2c.1.8.1 1.7.1 2.5s0 1.5-.1 2.3v.6c0 .6-.1 1.2-.2 1.8 0 .2 0 .3-.1.5-.7 4.9-2.3 9.4-4.7 13.5l-3.1 5.4-.4.7L78.7 165h1.1l35.7-62.5c.5-.9 1-1.9 1.5-2.9 2.3-4.8 3.6-10.2 3.6-15.9-.1-3.4-.6-6.8-1.5-10.1z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-7 -7)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    fillOpacity: 0.2,
    d: "M89.6 7.9c45.5 0 82.3 36.7 82.6 82.1v-.5C172.2 44 135.2 7 89.6 7S7 44 7 89.6v.5C7.3 44.7 44.1 7.9 89.6 7.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3E2723",
    fillOpacity: 0.15,
    d: "M89.6 171.3c45.5 0 82.3-36.7 82.6-82.1v.5c0 45.6-37 82.6-82.6 82.6S7 135.2 7 89.6v-.5c.3 45.4 37.1 82.2 82.6 82.2z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "j",
    cx: 31.676,
    cy: 137.277,
    r: 165.924,
    gradientTransform: "matrix(1 0 0 -1 -7 159.82)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("circle", {
    fill: "url(#j)",
    cx: 82.6,
    cy: 82.6,
    r: 82.6
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#757575",
    d: "M210.2 84.7c0-17.8 12.5-31.4 30.3-31.4 14.1 0 22 8.4 25.6 16.7l-9.9 4.7c-2.6-6.8-8.4-11-16.2-11-9.4 0-18.3 8.4-18.3 21.4 0 12.5 8.9 21.4 18.3 21.4 8.4 0 14.1-4.2 17.3-11l9.9 4.2c-3.7 8.4-12 16.7-26.1 16.7-18.4-.3-30.9-13.9-30.9-31.7zM286 55.4l-.5 8.4h.5c3.1-5.2 10.5-9.9 18.8-9.9 15.2 0 22.5 9.9 22.5 24.6v36.1h-11V80c0-12-6.3-16.2-14.6-16.2-9.4 0-15.7 8.9-15.7 18.3v32.4h-11V28.8h11v26.6zm52.8 59.1V55.4h10.5v9.4h.5c2.6-6.8 11-11 17.3-11 3.7 0 5.8.5 8.4 1.6l-4.2 10.5c-1.6-.5-3.7-1-5.8-1-7.3 0-15.2 6.3-15.2 17.3v32.4h-11.5zm97.3-29.8c0 17.8-12.5 31.4-30.3 31.4s-30.3-13.6-30.3-31.4 12.5-31.4 30.3-31.4 30.3 13.6 30.3 31.4zm-11 0c0-13.6-9.4-21.4-19.3-21.4s-19.3 7.8-19.3 21.4 9.4 21.4 19.3 21.4 19.3-7.8 19.3-21.4zm19.8-29.3h10.5v8.4h.5c3.1-5.8 11-9.9 18.3-9.9 9.4 0 15.7 4.2 18.8 11.5 4.2-6.8 11.5-11.5 20.4-11.5 14.1 0 20.9 9.9 20.9 24.6v36.1h-11.5V80c0-12-4.7-16.2-13.1-16.2-8.9 0-15.2 8.9-15.2 18.3v32.4h-11V80c0-12-4.7-16.2-13.1-16.2-8.9 0-15.2 8.9-15.2 18.3v32.4h-11V55.4h.7zm97.3 29.3c0-16.7 11.5-31.4 28.8-31.4s28.8 12.5 28.8 31.4v2.1h-46.5c.5 12.5 9.4 19.3 18.8 19.3 6.3 0 13.1-2.6 16.2-9.9l9.9 4.2c-3.7 8.4-12 16.2-25.6 16.2-18.4-.5-30.4-14.1-30.4-31.9zm28.7-20.9c-8.4 0-14.6 5.8-16.7 14.1h34c-.5-5.2-4.7-14.1-17.3-14.1z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChrome);
export default __webpack_public_path__ + "static/media/chrome.e2b4e79815400aeac259a1839e7e7816.svg";
export { ForwardRef as ReactComponent };